import React, { useEffect, useState } from 'react';
import { Icon } from '../ui/Icon';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-black border-t-2 border-yellow-500 shadow-2xl transform transition-transform duration-300" data-id="element-211">
      <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-212">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-213">
          <div className="text-center sm:text-left" data-id="element-214">
            <div className="text-yellow-400 font-bold text-lg mb-1" data-id="element-215">
              Black Friday Special — Solo $497
            </div>
            <div className="text-gray-300 text-sm" data-id="element-216">
              Acceso completo al Bootcamp + Bonos
            </div>
          </div>

          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/Y6gGK" className="group inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-400 hover:to-yellow-500 text-black px-8 py-3 rounded-lg font-bold transition-all duration-300 hover:scale-105 whitespace-nowrap" data-id="element-217">
            Asegurar Mi Acceso
            <Icon name="arrow-right" size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-218" />
          </a>
        </div>
      </div>
    </div>;
}